/** @type {import('../schema').ProcessDefinition} */
const permisos = {
  id: "permisos",
  name: "Permisos por rol/pantalla",
  category: "personas",
  outcome:
    "Cada admin/rol tiene acceso granular por pantalla, gestionable sin tocar código.",
  trigger: "El Super Admin abre Permisos Admin / Permisos Usuario.",
  actors: ["Super Admin", "Sistema", "Administrador"],
  status: "COMPLETO",
  description:
    "Edición granular de permisos por pantalla para un admin o rol, persistencia y evaluación en cada acceso.",
  lanes: [
    { id: "sa", actor: "Super Admin" },
    { id: "sys", actor: "Sistema" },
    { id: "admin", actor: "Administrador" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "sa",
      type: "start",
      label: "Selección",
      description:
        "Elige un admin (o un rol por edificio) para configurar permisos.",
      evidence: "src/screens/PermisosAdmin.jsx",
    },
    {
      id: "s2",
      laneId: "sa",
      type: "task",
      label: "Edición en la grilla",
      description:
        "Activa/desactiva pantallas en una grilla de permisos.",
      evidence: "src/components/PermissionGrid.jsx",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "document",
      label: "Guardado",
      description:
        "Persiste admin_permissions / role_permissions. Sin registro = todos los permisos en false (más seguro).",
    },
    {
      id: "s4",
      laneId: "admin",
      type: "task",
      label: "Acceso a una pantalla",
      description:
        "El Administrador intenta entrar a una pantalla del panel.",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "decision",
      label: "¿Tiene permiso?",
      description:
        "En cada acceso valida el permiso (cliente).",
      evidence: "src/hooks/usePermissions.js",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "end",
      label: "Acceso concedido",
    },
    {
      id: "s7",
      laneId: "admin",
      type: "end",
      label: "403 sin permiso",
      description:
        "Si falta el permiso, muestra 403. Permiso revocado → pierde acceso al recargar.",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "Permitido" },
    { from: "s5", to: "s7", label: "Denegado" },
  ],
};
export default permisos;
